import { isMobile } from "components/utility/page-responsive/PageResponsive";

const chooseHandler = (entry) => {
	if (entry.target.classList.contains("ddiff-animated-section-header")) {
		if (entry.isIntersecting && !isMobile()) {
			const headlineBorder = entry.target.querySelector(".ddiff-animated-section-border");
			if (headlineBorder) headlineBorder.classList.add("ddiff-animated-section-border-animate");
			animatedSectionHeaderObserver.unobserve(entry.target);
		} else if (entry.isIntersecting && isMobile()) {
			animatedSectionHeaderObserver.unobserve(entry.target);
		}
	}
};

const animatedSectionHeaderObserver = new IntersectionObserver(
	(entries) =>
		entries.forEach((entry) => {
			chooseHandler(entry);
		}),
	{
		root: null,
		rootMargin: `0px 0px -10% 0px`,
		threshold: 0
	}
);

export const observeAnimatedSectionHeaders = () => {
	const sectionHeaderObservableElements = document.querySelectorAll(".ddiff-observable-distance");
	sectionHeaderObservableElements.forEach((element) => {
		if (element) {
			animatedSectionHeaderObserver.observe(element);
		}
	});
};

export const animatedSectionHeadersDisconnect = () => {
	animatedSectionHeaderObserver.disconnect();
};
